import { increaseHoursInDate } from 'utils/dates'

const { z } = require('zod')

const emailSchema = z.union([z.literal(''), z.string().email()])

export const DataValidationSchema = () =>
	z.object({
		dataValidation: z
			.object({
				injuredNameValidation: z.boolean(),
				providedInjuredName: z.string().optional(),
				birthDateValidation: z.boolean(),
				providedBirthDate: z
					.string()
					.transform((date) =>
						date ? increaseHoursInDate(date, 12) : ''
					)
					.optional(),
				postalCode: z.string().optional(),
				email: z.string().optional(),
				nif: z.number().optional(),
				club: z.number().optional(),
				accidentDateValidation: z.boolean(),
				providedAccidentDate: z
					.string()
					.transform((date) =>
						date ? increaseHoursInDate(date, 12) : ''
					)
					.optional(),
			})
			.optional()
			.superRefine((data, ctx) => {
				if (
					data?.email &&
					!emailSchema.safeParse(data?.email).success
				) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'Invalid email',
						path: ['dataValidation', 'email'],
					})
				}

				if (
					data?.injuredNameValidation === false &&
					data?.providedInjuredName === undefined
				) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'Required',
						path: ['dataValidation', 'providedInjuredName'],
					})
				}

				if (
					data?.birthDateValidation === false &&
					data?.providedBirthDate === undefined
				) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'Required',
						path: ['dataValidation', 'providedBirthDate'],
					})
				}

				if (
					data?.accidentDateValidation === false &&
					data?.providedAccidentDate === undefined
				) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'Required',
						path: ['dataValidation', 'providedAccidentDate'],
					})
				}
			}),
	})

export const OptionalDataValidationSchema = z.object({
	dataValidation: z
		.object({
			injuredNameValidation: z.boolean().optional(),
			providedInjuredName: z.string().optional(),
			birthDateValidation: z.boolean().optional(),
			providedBirthDate: z
				.string()
				.transform((date) =>
					date ? increaseHoursInDate(date, 12) : ''
				)
				.optional(),
			postalCode: z.string().optional(),
			email: z.string().optional(),
			nif: z.number().optional(),
			club: z.number().optional(),
			accidentDateValidation: z.boolean().optional(),
			providedAccidentDate: z
				.string()
				.transform((date) =>
					date ? increaseHoursInDate(date, 12) : ''
				)
				.optional(),
		})
		.optional()
		.superRefine((data, ctx) => {
			if (data?.email && !emailSchema.safeParse(data?.email).success) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'Invalid email',
					path: ['dataValidation', 'email'],
				})
			}

			// NIF is optional, but when filled it must have exactly 9 digits.
			if (data?.nif !== undefined && String(data.nif).length !== 9) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'NIF must have 9 digits',
					path: ['dataValidation', 'nif'],
				})
			}
		}),
})
